import { EntitySchedulePreference } from './EntitySchedulePreference';

/**
 * A DefaultEntitySchedulePreference represents a schedule preference that was inherited from a hospitals default schedule template
 * As such it's entity ID will be for that entity (vet for example, so 0), and the entity preferenceId will be from the preference on the default template
 * Since this preference isn't actually from the entity presented by the entityId there are two extra fields here so you know it came from a template, templateId is that template.
 * If these fields are present on an entityscheduleprefernece, it was inherited from a default template.
 */
export class DefaultEntitySchedulePreference extends EntitySchedulePreference {
  templateId: number;
  inheritedFromTemplate: boolean;

  constructor(init: DefaultEntitySchedulePreference) {
    super(init);

    this.templateId = init.templateId;
    this.inheritedFromTemplate = init.inheritedFromTemplate;
  }
}
